export default __webpack_public_path__ + "static/media/aging.6db36096.png";